<template>
  <v-list-item @click="$emit('itemClick', item)">
    <v-list-item-avatar v-if="showAvatar">
      <v-avatar color="primary" size="56">
        <span class="white--text font-weight-bold">{{ initials }}</span>
      </v-avatar>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        <span>{{ item.title }}</span>
        <v-icon small class="ml-2" v-if="item.ordered">mdi-cart-check</v-icon>
      </v-list-item-title>
      <v-list-item-subtitle class="mr-1 text-wrap">
        <span>{{ getOrderDateString(item) }}</span
        ><br v-if="getOrderDateString(item)" />
        <span>{{ getDeliveryDateString(item) }}</span
        ><br v-if="getDeliveryDateString(item)" />
        {{ getLastEditedString(item) }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-btn
        color="primary"
        fab
        x-small
        depressed
        @click="$emit('duplicateClick', item)"
        v-if="item.ordered"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
      <v-menu :close-on-click="true" v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            fab
            x-small
            depressed
            v-bind="attrs"
            v-on="on"
            @click.prevent
            @mousedown.stop
            @touchstart.native.stop
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="$emit('duplicateClick', item)">
            <v-list-item-icon>
              <v-icon>mdi-content-copy</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Duplizieren</v-list-item-title>
          </v-list-item>
          <v-list-item @click="onDeleteClicked(item)" :disabled="item.ordered">
            <v-list-item-icon>
              <v-icon>mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Löschen</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
    <DialogConfirm
      ref="deleteDialog"
      caption="Schacht wirklich"
      title="löschen?"
      message="Diese Aktion kann nicht mehr rückgängig gemacht werden."
      ok="Ja, löschen"
      cancel="Nein"
    />
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getLastEditedString,
  getOrderDateString,
  getDeliveryDateString,
} from '@/utils/utils';
import DialogConfirm from '@/components/DialogConfirm.vue';

export default {
  name: 'ShaftListItem',
  components: { DialogConfirm },
  props: ['item', 'showAvatar'],
  computed: {
    ...mapGetters(['user']),
    initials() {
      if (!this.item) return '';
      return this.item.title.substring(0, 2).toUpperCase();
    },
    updatedUser() {
      if (this.item && this.item.user_updated && this.item.user_updated.user)
        return this.item.user_updated.user;
      if (this.item && this.item.user_updated) return this.item.user_updated;
      return undefined;
    },
    userNamesVisible() {
      if (
        this.item &&
        this.item.site_id.company &&
        this.item.site_id.company.users &&
        this.item.site_id.company.users.length > 1
      )
        return true;
      return false;
    },
  },
  methods: {
    getLastEditedString,
    getOrderDateString,
    getDeliveryDateString,
    async onDeleteClicked(item) {
      var result = await this.$refs.deleteDialog.show();
      if (result) {
        this.$emit('deleteClick', item);
      }
    },
  },
};
</script>
